import request, { queryWithSilentSilentSignin } from '@/utils/request'
import axios from 'axios'
// 神策自定义埋点
import { getParams } from '@/utils/logTrack'
const url_prefix = process.env.VUE_APP_API_URL
const upload_url = process.env.VUE_APP_API_URL_UPLOAD
const url_prefix_pro = 'https://chatglm.cn/chatglm' // 目前只支持线上，固定

export function collectConversation(log_id) {
  return request(
    {
      url: `${url_prefix}/feed-api/favourite/info/${log_id}`,
      method: 'post'
    },
    {
      loading: false
    }
  )
}

export function cancelCollect(log_id) {
  return request(
    {
      url: `${url_prefix}/feed-api/favourite/info/${log_id}`,
      method: 'delete'
    },
    {
      loading: false
    }
  )
}

export function getCollectionList(data) {
  return request(
    {
      url: `${url_prefix}/feed-api/favourite/list`,
      method: 'get',
      params: data
    },
    {
      loading: false
    }
  )
}

// 客户端配置数据
export function getClientConfig() {
  return queryWithSilentSilentSignin(
    {
      url: `${url_prefix}/backend-api/v1/operation_data?tag=clientConfig`,
      method: 'get'
    },
    {
      withToken: false,
      loading: false,
      errorMessageShow: false
    }
  )
}
// 多模数据
export function getOperationData() {
  return queryWithSilentSilentSignin(
    {
      url: `${url_prefix_pro}/backend-api/v1/operation_data?tag=text2img`,
      method: 'get'
    },
    {
      withToken: false,
      loading: false,
      errorMessageShow: false
    }
  )
}

// 用户注册
export function register(data) {
  data = Object.assign(data, getParams())
  return request(
    {
      url: `${url_prefix}/backend-api/v1/user/signup`,
      method: 'post',
      data
    },
    {
      withToken: false
    },
    {
      text: '注册中...'
    }
  )
}

// 热点
export async function getHeat(data) {
  return request({
    url: `${url_prefix}/backend-api/v1/inspiration/info`,
    method: 'post',
    data
  })
}

export async function updateHeat(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/inspiration/operation`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}

// 登录
// md5链接是v3, data需要多传递一个encrypt_phone 字段
export function login(data) {
  // let version = 'v1'
  // if (data.encrypt_phone) {
  //   version = 'v3'
  // }
  // 统一走v1版login接口，删除encrypt_phone参数
  delete data.encrypt_phone
  data = Object.assign(data, getParams())
  return request(
    {
      url: `${url_prefix}/backend-api/v1/user/login`,
      method: 'post',
      data
    },
    {
      withHeadersFr: true,
      withToken: false
    },
    {
      text: '登录中...'
    }
  )
}

// 修改密码
export function updatePwd(data) {
  return request({
    url: `${url_prefix}/backend-api/v1/user/resetpass`,
    method: 'post',
    data
  })
}

// 用户个人属性
export function getUserProfile() {
  return request(
    {
      url: `${url_prefix}/user-api/user/profile`,
      method: 'get'
    },
    {
      loading: false
    }
  )
}

// 修改昵称
export function updateNickname(data) {
  return request(
    {
      url: `${url_prefix}/user-api/user/nickname`,
      method: 'put',
      data
    },
    {
      loading: false
    }
  )
}

// 修改昵称
export function updateUserAvatar(data) {
  return request(
    {
      url: `${url_prefix}/user-api/user/avatar`,
      method: 'put',
      data
    },
    {
      loading: false,
      errorMessageShow: false
    }
  )
}

// 退出登录
export function logout() {
  return request(
    {
      url: `${url_prefix}/user-api/user/logout`,
      method: 'post'
    },
    {
      text: '退出登录中...'
    }
  )
}

// 注销
export function signout() {
  return request(
    {
      url: `${url_prefix}/backend-api/v3/user/sign_out`,
      method: 'get',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      params: {
        fr: 'web'
      }
    },
    {
      loading: false
    }
  )
}

// 获取用户信息
export function getUserInfo() {
  return request(
    {
      url: `${url_prefix}/user-api/user/info`,
      method: 'get',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    },
    {
      loading: false
    }
  )
}

// 发送学校信息

export function updateUniversity(univ) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/user/register_university?institution=${univ}`,
      method: 'get'
    },
    {
      loading: false
    }
  )
}

// 获取微信登录二维码-生成一个微信二维码。//[关于微信快速登录功能的说明-微信官方文档](https://developers.weixin.qq.com/doc/oplatform/Website_App/WeChat_Login/Wechat_Login.html);
export const getWeChatQrCodeImage = () => {
  const thePromise = new Promise((resolve, reject) => {
    ;(async () => {
      const result = {
        statusString: `fail`, // 默认失败。
        returnObject: null
      }
      // 延时过去，保证必定有返回值。
      setTimeout(() => {
        return resolve(result)
      }, 10000)

      try {
        // [微信快速登录功能](https://developers.weixin.qq.com/doc/oplatform/Website_App/WeChat_Login/Wechat_Login.html);
        let url = 'https://chatglm.cn/WeChatLoginTransit'
        if (location.origin !== 'https://chatglm.cn') {
          url = `https://chatglm.cn/wx/code/page?path=WeChatLoginTransit&origin=${location.origin}`
        }
        const theObject = new window.WxLogin({
          self_redirect: true, // true：手机点击确认登录后可以在 iframe 内跳转到 redirect_uri，false：手机点击确认登录后可以在 top window 跳转到 redirect_uri。默认为 false。;
          id: 'qrCodeWeChatInject', // 第三方页面显示二维码的容器id;
          appid: 'wx7b19c27985d99d60', // 第三方页面显示二维码的容器id;
          scope: 'snsapi_login', // 应用授权作用域，拥有多个作用域用逗号（,）分隔，网页应用目前仅填写snsapi_login即可;
          redirect_uri: encodeURIComponent(url), //	重定向地址，需要进行UrlEncode;
          state: 'fangState88888My', // 用于保持请求和回调的状态，授权请求后原样带回给第三方。该参数可用于防止csrf攻击（跨站请求伪造攻击），建议第三方带上该参数，可设置为简单的随机数加session进行校验;
          style: '' // 提供"black"、"white"可选，默认为黑色文字描述。
          // href: `${location?.origin || `https://chatglm.cn`}/wechat-login/login.css` // 自定义样式链接，第三方可根据实际需求覆盖默认样式。
        })
        // console.log(`生成二维码返回值：theObject-->`, theObject)
        result.statusString = `success`
        result.returnObject = theObject
        return resolve(result)
      } catch (error) {
        console.log(`error:-->`, error)
        return resolve(result)
      }
    })()
  })
  return thePromise
}

// 微信扫码登录-根据login_code获取微信openid或登录信息。//[用户相关接口](https://zhipu-ai.feishu.cn/wiki/AdlbwE88IiL7eNkut0McEB45no3?from=from_copylink);
export const postWechatScanCodeLogin = async (data = {}) => {
  const params = {
    ...(data || {}),
    login_code: data?.login_code || ``, // 微信回调登录授权码;
    is_open_platform: data?.is_open_platform ?? true // 是否是开放平台;
  }
  console.log(`params-->`, params)
  console.log(`url_prefix-->`, url_prefix)

  return request(
    {
      url: `${url_prefix}/user-api/wechat/login`,
      method: 'post',
      data: params
    },
    {
      withHeadersFr: true,
      withToken: false
    }
    // {
    //   text: '发送中...'
    // }
  )
}

// 微信绑定手机号并进行登录-用于微信openid与手机号进行绑定并进行登录。//[用户相关接口](https://zhipu-ai.feishu.cn/wiki/AdlbwE88IiL7eNkut0McEB45no3?from=from_copylink);
export const postWeChatBindLogin = (data = {}) => {
  const params = {
    ...(data || {}),
    phone: data?.phone || ``, // 手机号;
    captcha: data?.captcha || ``, // 短信验证码;
    wechat_union_id: data?.wechat_union_id || ``, // 微信用户全局唯一标识;
    validation_id: data?.validation_id || ``, // 滑块验证码rid;
    sensors_id:
      data?.sensors_id || window?.sensorsDataAnalytic201505?.quick?.('getAnonymousID') || `` // 神策SDK获取的匿名ID;//参见`/src/main.js`中神策相关代码;
  }

  return request(
    {
      url: `${url_prefix}/user-api/user/phone_login`,
      method: 'post',
      data: params
    },
    {
      withToken: false,
      withHeadersFr: true,
      errorMessageShow: false
    }
  )
}

// 通过期刊画册id获取期刊画册信息。//[用户相关接口](https://zhipu-ai.feishu.cn/wiki/AdlbwE88IiL7eNkut0McEB45no3?from=from_copylink);
export const getAlbumInfo = (data = {}) => {
  const params = {
    ...(data || {}),
    id: data?.id || `` // 画册id;
  }
  if (!data?.id) {
    delete params.id
  }

  return request(
    {
      url: `${url_prefix}/feed-api/album/info`,
      method: 'get',
      params: params
    },
    {
      withToken: false,
      errorMessageShow: false
    }
  )
}

// 发送验证码
export function sendCode(data) {
  // 删除md5参数
  delete data.md5
  data = Object.assign(data, getParams())

  return request(
    {
      url: `${url_prefix}/backend-api/v1/user/checkphone`,
      method: 'post',
      data
    },
    {
      withToken: false
    }
    // {
    //   text: '发送中...'
    // }
  )
}

// 拿task_id方法一
export function getChatGlmTaskId(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/completions_130B_async`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}

// 拿task_id方法二
export async function getTaskId(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/conversation`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}

// 用task_id换取提问的结果
// export function getGlmStatus(task_id) {
//   return request(
//     {
//       url: `${url_prefix}/api/v2/status`,
//       method: 'get',
//       params: {
//         task_id
//       }
//     },
//     {
//       loading: false
//     }
//   )
// }

// 获取chatGLM提问的例子
export function getGlmExamples(params) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/examples`,
      method: 'get',
      params: params || {
        max_num: 3
      }
    },
    {
      loading: false
    }
  )
}

// 获取版本号
export function getVersionNum() {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/model_version`,
      method: 'get'
    },
    {
      loading: false
    }
  )
}

// 点赞 && 踩
export function thumbsUp(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/score`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}

// 手动停止
export function manualStop(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/manualstop?__requestid=${data?.task_id || ''}`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}

// 发送验证码
export function getVerificationCode() {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/user/imgCode`,
      method: 'post'
    },
    {
      loading: false
    }
  )
}

// data: { "md5": "string"}
export async function verifyMD5API(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/v3/user/verify`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}

// data: {url: string,code: string}
export async function verifyImgCode(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/user/verify_imgCode`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}

// 拿用户conversation列表
export function getConversationList(params) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/conversation/list`,
      method: 'get',
      params: params || {
        size: 50,
        offset: 0,
        type: 'default'
      }
    },
    {
      loading: false
    }
  ).catch(() => {})
}

// 请求生成分享链接
export async function getShareLink(data) {
  return request({
    url: `${url_prefix}/backend-api/v1/conversation/share/create`,
    method: 'post',
    data
  })
}

export async function getShareContent(conversationId) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/conversation/share/get/${conversationId}`,
      method: 'get'
    },
    {
      withToken: false
    }
  )
}

export async function importShareContent(conversationId) {
  return request({
    url: `${url_prefix}/backend-api/v1/conversation/share/import/${conversationId}`,
    method: 'get'
  })
}

// 删除session
export function delConversation(id) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/conversation/delete/${id}`,
      method: 'get'
    },
    {
      loading: false
    }
  )
}

// 用id查具体信息
export function getSessionById(id) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/conversation/${id}`,
      method: 'get'
    },
    {
      loading: false
    }
  )
}

// 检测注册排队用户
export async function verifySignup(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/user/verify_signup`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}

// 刷新token
export async function refreshToken() {
  return queryWithSilentSilentSignin(
    {
      url: `${url_prefix}/user-api/user/refresh`,
      method: 'post'
    },
    {
      useRefreshToken: true,
      loading: false
    }
  )
}

// 内测邀请
export function internalApply(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/user/internal_application`,
      method: 'post',
      data
    },
    {
      withToken: false
    }
  )
}

// 发送手机验证码
export function sendCodeInTest(data) {
  return request({
    url: `${url_prefix}/backend-api/v1/user/send_sms`,
    method: 'post',
    data
  })
}

// stream context
export function sendStreamContext(data) {
  const __requestid = data.__requestid || ''
  // const __userid = data.__userid || ''
  delete data.__requestid
  // delete data.__userid
  const url = `${url_prefix}/backend-api/v1/stream_context?__requestid=${__requestid}`
  // if (__userid) {
  //   if (
  //     __userid[__userid.length - 1] === '0' ||
  //     __userid === '64586371deade211f83980e3' ||
  //     __userid === '642e7c00bacd25897b312881'
  //   ) {
  //     url = `https://origin.chatglm.cn/chatglm/backend-api/v1/stream_context?__requestid=${__requestid}`
  //   }
  // }
  return request(
    {
      url: url, // temp_for_0727
      // url: `${url_prefix}/backend-api/v1/stream_context?debug=1`, // temp_test
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}

// 实名认证
// data: {id_card:string,real_name:string}
export function RealNameAuth(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/user/real_name_authentication`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}
export function RealNameAuth2(formData) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/user/real_name`,
      method: 'post',
      data: formData
    },
    {
      loading: false
    }
  )
}
// 同意体验
// data: {phone:string}
export function AgreeExperience(data) {
  return request(
    {
      url: `${url_prefix}/backend-api/v3/user/agree_experience`,
      method: 'post',
      data
    },
    {
      loading: false
    }
  )
}

export function UpdateToken(saToken) {
  return request(
    {
      url: `${url_prefix}/backend-api/v2/user/login?satoken=${saToken}`,
      method: 'get'
    },
    {
      loading: false
    }
  )
}

export function openTeenagersMode(password) {
  return request(
    {
      url: `${url_prefix}/backend-api/v3/user/teen_open?password=${password}`,
      method: 'get'
    },
    {
      loading: false
    }
  )
}

export function closeTeenagersMode(password) {
  return request(
    {
      url: `${url_prefix}/backend-api/v3/user/teen_close?password=${password}`,
      method: 'get'
    },
    {
      loading: false
    }
  )
}

export function releaseTeenagersMode(password) {
  return request(
    {
      url: `${url_prefix}/backend-api/v3/user/teen_privilidge?password=${password}`,
      method: 'get'
    },
    {
      loading: false
    }
  )
}

/**
 * @returns '0'-清华，‘-1’-外网
 */
export function getRemoteIp() {
  return request(
    {
      url: `${url_prefix}/backend-api/v3/user/get_remote_ip`,
      method: 'get'
    },
    {
      loading: false
    }
  )
}

/**
 * 上传文档
 */
export function uploadFileRq({ file, url }) {
  const formData = new FormData()
  if (file) {
    formData.append('file', file)
  }
  if (url) {
    formData.append('url', url)
  }
  return axios({
    url: `${upload_url}/upload`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

/**
 * 解析文档
 */
export function parseFileRq(data) {
  return request(
    {
      url: `${url_prefix}/pdf/v1/parse`,
      // url: `${upload_url}/inner/parse`,
      method: 'POST',
      timeout: 1000 * 60,
      data
    },
    {
      loading: false
    }
  )
}

/**
 * 解析文档
 */
export function parseFileProgressRq(uuid) {
  return request(
    {
      url: `${url_prefix}/pdf/v1/parse/progress?uuid=${uuid}&_t=${Date.now()}`,
      method: 'GET'
    },
    {
      loading: false
    }
  )
}

/**
 * 获取插件列表
 */
export function getPluginList() {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/plugin_list`,
      method: 'get'
    },
    {
      loading: false
    }
  )
}

export function uploadImage(imgFile) {
  const formData = new FormData()
  if (imgFile) {
    formData.append('file', imgFile)
  }
  return request(
    {
      url: `${url_prefix}/backend-api/v1/image_upload`,
      // url: `${url_prefix}/backend-api/v1/stream_context?debug=1`, // temp_test
      method: 'post',
      data: formData
    },
    {
      loading: false
    }
  )
}

// 反馈举报
export function feedback(data) {
  return request({
    url: `${url_prefix}/backend-api/v1/feed_back`,
    method: 'post',
    data
  })
}

// 设置同步云盘
export function setSyncStorage(data) {
  return request({
    url: `${url_prefix}/user-api/user/setting/sync_storage`,
    method: 'put',
    data
  })
}
